import {api} from './Api';
import {Favorite} from '../models';

export const getFavorites = () => {
  return api.get(`favorite/`).then((res: any) => res.data);
};

export const createFavorite = (favorite: Partial<Favorite>) => {
  return api.post(`favorite/`, favorite).then((res: any) => res.data);
}

export const deleteFavorite = (uid: string) => {
  return api.delete(`favorite/${uid}`).then((res: any) => res.data);
}
